export default __webpack_public_path__ + "static/media/pg.a4a1866a.svg";